import { useQuery } from '@tanstack/vue-query';
import apiInterceptor from '@/shared/apiInterceptor';
import { environment } from '@/shared/env';

export const livechatBusinessRolesQueryOptions = {
  queryKey: ['livechat-business-roles'],
  queryFn: async () => {
    const r = await apiInterceptor.get(environment('VUE_APP_API_URL') + 'livechat/v1/core/business_roles');
    return { ...r, business_roles: [...(r.business_roles ?? [])] };
  },
  staleTime: Infinity,
};

export function useLivechatBusinessRoles() {
  return useQuery(livechatBusinessRolesQueryOptions);
}

